// extracted by mini-css-extract-plugin
export var shake = "_4-0";